import { theme as antdTheme } from "antd";
import { AN_DARK, AN_FONT, AN_LIGHT } from "../design-system/tokens";

// The antd theme for "light" or "dark".
export function antdThemeFor(mode) {
  const p = mode === "dark" ? AN_DARK : AN_LIGHT;
  return {
    token: {
      colorPrimary: p.primary,
      colorSuccess: p.success,
      colorError: p.danger,
      colorWarning: p.warn,
      colorTextBase: p.ink,
      colorBorder: p.line,
      colorBorderSecondary: p.line2,
      colorBgLayout: p.bgWarm,
      ...(mode === "dark" ? { colorBgContainer: p.surface, colorBgElevated: p.elevated } : {}),
      borderRadius: 7,
      fontSize: 14,
      fontFamily: AN_FONT,
      fontWeightStrong: 600,
    },
    algorithm: mode === "dark" ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
  };
}

const theme = antdThemeFor("light");

export default theme;
